import { render, staticRenderFns } from "./PItemMeasureUnitsSearch.vue?vue&type=template&id=96d8b1e6"
import script from "./PItemMeasureUnitsSearch.vue?vue&type=script&lang=js"
export * from "./PItemMeasureUnitsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports